/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audit_Details_Project_Private_Chats_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "Private chats were turned off for project \"{name}\": every member sees everyone's chats again." |
*
* @param {Audit_Details_Project_Private_Chats_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_private_chats_disabled_desc = /** @type {((inputs: Audit_Details_Project_Private_Chats_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Private_Chats_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Private Chats wurden für das Projekt "${i?.name}" deaktiviert: Alle Mitglieder sehen wieder die Chats aller Mitglieder.`)
	return /** @type {LocalizedString} */ (`Private chats were turned off for project "${i?.name}": every member sees everyone's chats again.`)
});